import React from "react";
import { Box, Typography, ButtonBase } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// Define languages with flags and labels
const LANGUAGES = [
  {
    code: "ar",
    label: "العربية",
    flag: "🇸🇦",
    subtitle: "تغيير لغة الموقع للغة العربية",
  },
  //   {
  //     code: "en",
  //     label: "English",
  //     flag: "🇺🇸",
  //     subtitle: "Switch website language to English",
  //   },
];

function LanguageBox({ currentLang, onLangChange }) {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 360,
        backgroundColor: "#ffffff",
        borderRadius: "16px",
        boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.08)",
        border: "1px solid #f0f0f0",
        display: "flex",
        flexDirection: "column",
        // gap: "12px",
        // Soft entry animation
        animation: "fadeIn 0.3s ease-out",
        "@keyframes fadeIn": {
          from: { opacity: 0, transform: "scale(0.95)" },
          to: { opacity: 1, transform: "scale(1)" },
        },
      }}
    >
      {/* Box Header */}
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 700,
          color: "#1a1a1a",
          textAlign: currentLang === "ar" ? "right" : "left",
          fontSize: "1.1rem",
          marginBottom: "4px",
          padding: "5px 0 0 5px",
        }}
      >
        {currentLang === "ar" ? "اختر اللغة" : "Select Language"}
      </Typography>

      {/* Language Options Options */}
      {LANGUAGES.map((lang) => {
        const isSelected = currentLang === lang.code;

        return (
          <ButtonBase
            key={lang.code}
            // onClick={() => onLangChange(lang.code)}
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "14px 16px",
              borderRadius: "12px",
              backgroundColor: isSelected ? "#f4fcf7" : "#fafafa",
              border: `2px solid ${isSelected ? "#10b981" : "transparent"}`,
              transition: "all 0.2s ease",
              flexDirection: currentLang === "ar" ? "row-reverse" : "row",
              "&:hover": {
                backgroundColor: isSelected ? "#edfbf3" : "#f0f0f0",
                transform: "translateY(-1px)",
              },
            }}
          >
            {/* Left Content (Flag + Text labels) */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "14px",
                flexDirection: currentLang === "ar" ? "row-reverse" : "row",
                textAlign: currentLang === "ar" ? "right" : "left",
              }}
            >
              {/* Flag Badge Container */}
              <Box
                sx={{
                  width: "100&",
                  borderRadius: "10px",
                  backgroundColor: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.4rem",
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.04)",
                }}
              >
                {lang.flag}
              </Box>

              {/* Text Meta Content */}
              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "0.95rem",
                    color: isSelected ? "#065f46" : "#2d3748",
                  }}
                >
                  {lang.label}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    color: "#718096",
                    marginTop: "2px",
                  }}
                >
                  {lang.subtitle}
                </Typography>
              </Box>
            </Box>

            {/* Selection Checkmark Node */}
            <Box
              sx={{
                width: "22px",
                height: "22px",
                borderRadius: "50%",
                border: `2px solid ${isSelected ? "#10b981" : "#cbd5e0"}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: isSelected ? "#10b981" : "transparent",
                transition: "all 0.2s ease",
              }}
            >
              {isSelected && (
                <CheckCircleIcon sx={{ fontSize: "24px", color: "#ffffff" }} />
              )}
            </Box>
          </ButtonBase>
        );
      })}
    </Box>
  );
}
export default React.memo(LanguageBox);
